<script setup>
import { themeConfig } from '@themeConfig'

// Components
import NavbarThemeSwitcher from '@/layouts/components/NavbarThemeSwitcher.vue'
import UserProfile from '@/layouts/components/UserProfile.vue'
import { HorizontalNavLayout } from '@layouts'

import Logo from '@/components/Logo.vue'
import { authStore } from '@/store/auth' // import the auth store we just created
import ContentSwitcher from './ContentSwitcher.vue'

const { menu } = storeToRefs(authStore())
</script>

<template>
  <HorizontalNavLayout :nav-items="menu">
    <!-- 👉 navbar -->
    <template #navbar>
      <VSpacer />
      <NuxtLink
        to="/"
        class="app-logo d-flex align-center gap-x-3"
      >
        <Logo />

        <h1 class="app-title font-weight-bold leading-normal text-xl text-capitalize">
          {{ themeConfig.app.appName }}
        </h1>
      </NuxtLink>
      <VSpacer />
      <!--
        <NavBarI18n
        v-if="themeConfig.app.i18n.enable && themeConfig.app.i18n.langConfig?.length"
        :languages="themeConfig.app.i18n.langConfig"
        />
      -->
      <ContentSwitcher class="me-2" />
      <NavbarThemeSwitcher class="me-2" />
      <UserProfile />
    </template>

    

    <!-- 👉 Pages -->
    <slot />

    <!-- 👉 Footer -->
    <template #footer>
      <Footer />
    </template>

    <!-- 👉 Customizer -->
    <!-- <TheCustomizer /> -->
  </HorizontalNavLayout>
</template>

<style lang="scss">
.app-logo{
  svg{
    height: 22px;
  }
}
</style>
